/* ============================================================
   KLOHEMA — Filtro y orden en página de colección
   ============================================================ */
(function () {
  const grid = document.querySelector(".kl-coll-grid");
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll(".kl-product"));
  const count = document.querySelector(".kl-coll-count");

  function refreshCount() {
    const n = cards.filter((c) => !c.classList.contains("is-hidden")).length;
    if (count) count.textContent = n + (n === 1 ? " pieza" : " piezas");
  }

  const chips = document.querySelectorAll(".kl-chip");
  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      chips.forEach((c) => c.setAttribute("aria-pressed", "false"));
      chip.setAttribute("aria-pressed", "true");
      const cat = chip.dataset.cat;
      cards.forEach((card) => {
        const show = cat === "all" || card.dataset.cat === cat;
        card.classList.toggle("is-hidden", !show);
      });
      refreshCount();
    });
  });

  const sortSel = document.querySelector(".kl-sort select");
  if (sortSel) {
    sortSel.addEventListener("change", () => {
      const v = sortSel.value;
      const sorted = [...cards].sort((a, b) => {
        const pa = +a.dataset.price, pb = +b.dataset.price;
        if (v === "price-asc") return pa - pb;
        if (v === "price-desc") return pb - pa;
        return (+a.dataset.order) - (+b.dataset.order);
      });
      sorted.forEach((c) => grid.appendChild(c));
    });
  }

  refreshCount();
})();
